/* global dataLayer */

import { Controller } from 'stimulus';
import { getCLS, getFID, getLCP } from 'web-vitals';

class Tracking extends Controller {
  connect() {
    this.trackTiming();
  }

  trackTiming() {
    getCLS(this.sendToGTM);
    getFID(this.sendToGTM);
    getLCP(this.sendToGTM);
  }

  // eslint-disable-next-line class-methods-use-this
  sendToGTM({ name, delta, id }) {
    dataLayer.push({
      event: 'web-vitals',
      event_category: 'Web Vitals',
      event_action: name,
      // The `id` value will be unique to the current page load. When sending
      // multiple values from the same page (e.g. for CLS), Google Analytics can
      // compute a total by grouping on this ID (note: requires `eventLabel` to
      // be a dimension in your report).
      event_label: id,
      // Google Analytics metrics must be integers, so the value is rounded.
      // For CLS the value is first multiplied by 1000 for greater precision
      // (note: increase the multiplier for greater precision if needed).
      event_value: Math.round(name === 'CLS' ? delta * 1000 : delta),
      // Use a non-interaction event to avoid affecting bounce rate.
      non_interaction: true,
    });
  }
}

Tracking.targets = [
  //
];

export default Tracking;
